import * as React from 'react';
import { BannerType, Button, Card, DatePicker, Dropdown, TimePicker, Typography, } from '@symphony-ui/uitoolkit-components';
import { sendFetchError, sendMessage } from 'utils/messageUtils';
import ApiServerURL from 'models/ApiServerUrl';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import useOption from 'components/customHooks';
import { datePattern } from 'components/custom-table/dateFormat';
const SyndDbManagement = () => {
    const { apiFetchNoContent } = React.useContext(DownloadContext);
    const [from, setFrom] = React.useState();
    const [beforeDate, setBeforeDate] = React.useState();
    const [beforeTime, setBeforeTime] = React.useState();
    const [path, setPath] = React.useState();
    const options = useOption('/syndicate/system/options');
    const onChange = React.useCallback((event) => {
        setPath(event.target.value.value);
    }, []);
    const onChangeFrom = React.useCallback((event) => {
        setFrom(event.target.value);
    }, []);
    const onChangeBeforeDate = React.useCallback((event) => {
        setBeforeDate(event.target.value);
    }, []);
    const onChangeBeforeTime = React.useCallback((event) => {
        setBeforeTime(event.target.value);
    }, []);
    const onClick = React.useCallback(() => {
        if (path !== undefined) {
            const url = new ApiServerURL(`/syndicate/system/${path}`);
            if (from !== undefined) {
                url.searchParams.append('from', from.toISOString());
            }
            if (beforeDate !== undefined) {
                const isoString = beforeDate.toISOString().substring(0, 10) + "T" + (beforeTime ?? "00:00:00") + ".000Z";
                url.searchParams.append('before', isoString);
            }
            const request = new ApiServerRequest(url);
            (async () => {
                try {
                    await apiFetchNoContent(request);
                    const text = options.find((o) => o.value === path)?.label ?? "ERROR";
                    sendMessage("Started: " + text, BannerType.SUCCESS);
                }
                catch (error) {
                    sendFetchError(`Unable to execute DB management for ${path}`, error, request);
                }
            })();
        }
    }, [path, from, beforeDate, beforeTime, apiFetchNoContent, options]);
    const isDisabled = React.useMemo(() => (path === '' || path === undefined), [path]);
    return (React.createElement(Card, { style: { height: 'min-content', marginBottom: '1rem', padding: '1rem' } },
        React.createElement(Typography, { type: "h1" }, "Database Management"),
        React.createElement("div", { style: { display: 'flex', width: '100%' } },
            React.createElement("div", { style: { width: '100%' } },
                React.createElement(Dropdown, { size: "large", label: "Select a task", name: "type", onChange: onChange, options: options, value: options.find((o) => o.value === path), width: "100px" })),
            React.createElement("div", { style: { alignSelf: 'center', marginLeft: '1rem' } },
                React.createElement(DatePicker, { date: beforeDate, disabledDays: [{ before: new Date(2022, 1, 17) }, { after: new Date() }], format: datePattern(), label: "Ignore anything", onChange: onChangeBeforeDate })),
            React.createElement("div", { style: { alignSelf: 'center', marginLeft: '1rem', width: '14rem' } },
                React.createElement(TimePicker, { label: "checked after", value: beforeTime, onChange: onChangeBeforeTime })),
            React.createElement("div", { style: { alignSelf: 'center', marginLeft: '1rem' } },
                React.createElement(DatePicker, { date: from, disabledDays: [{ before: new Date(2022, 1, 17) }, { after: new Date() }], format: datePattern(), label: "Restrict to data from", onChange: onChangeFrom })),
            React.createElement("div", { style: { alignSelf: 'center', marginLeft: '1rem' } },
                React.createElement(Button, { disabled: isDisabled, onClick: onClick, type: "button" }, "GO")))));
};
export default SyndDbManagement;
